import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule, MatIconModule, MatRippleModule } from '@angular/material';
import { StepsModule } from './steps/steps.module';
import { TutorialButtonComponent } from './tutorial-button/tutorial-button.component';
import { TutorialService } from './tutorial.service';
import { TutorialPanelComponent } from './tutorial-panel/tutorial-panel.component';
import { TutorialComponent } from './tutorial/tutorial.component';

@NgModule({
  declarations: [
    TutorialButtonComponent,
    TutorialPanelComponent,
    TutorialComponent,
  ],
  exports: [
    TutorialButtonComponent,
    TutorialPanelComponent,
    TutorialComponent,
  ],
  entryComponents: [
    TutorialButtonComponent,
    TutorialPanelComponent,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    StepsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
  ],
  providers: [
    { provide: TutorialService, useClass: TutorialService }
  ]
})
export class TutorialModule { }
